import Joi from '@hapi/joi'

export const PluckingAndSundryLabourChecklistObject = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Group Name cannot have invalid characters`,
        "any.required": `Group Name characters`
    }),
    estateID: Joi.number().required().label("Estate Name").messages({
        "any.invalid": `Estate Name cannot have invalid characters`,
        "any.required": `Estate Name characters`
    }),
    divisionID: Joi.number().required().label("Division Name").messages({
        "any.invalid": `Division Name cannot have invalid characters`,
        "any.required": `Division Name Type characters`
    }),
    empType: Joi.number().required().label("Employee Category").messages({
        "any.invalid": `Employee Category cannot have invalid characters`,
        "any.required": `Employee Category Type characters`
    }),
    searchDate: Joi.string().invalid("").label("Search Date"),
}